import type {
  GameState,
  DailyMode,
  Puzzle,
} from '../types';
import { PersistedState } from 'runed';
import localforage from 'localforage';
import { browser } from '$app/env';

if (browser) {
  localforage.config({
    driver: [
      localforage.INDEXEDDB,
      localforage.WEBSQL,
      localforage.LOCALSTORAGE,
    ],
    name: 'gramjam',
    version: 1.0,
    storeName: 'gameStore',
  });
  // TODO cleanup in migration: remove old dictionary store
  localStorage.removeItem('dictionary');
  localStorage.removeItem('dictionary-md5');
}

type ModeSettings = Pick<GameState, 'type' | 'remainingSwaps' | 'dims'>;

type DailyModeSettings = ModeSettings & { type: 'daily'; mode: DailyMode };

export const dailySettings = (mode: DailyMode): DailyModeSettings => ({
  type: 'daily',
  mode,
  remainingSwaps: mode === '5x5' ? 18 : 20,
  dims: mode === '5x5' ? [5, 5] : [6, 6],
});

export const isGame = (game?: GameState | Puzzle | null): game is GameState =>
  game != undefined && !!game.id;

export const gamesPlayed = new PersistedState('gamesPlayed', 0);
